/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var TrackedLinkModel = /** @class */ (function () {
    function TrackedLinkModel() {
    }
    TrackedLinkModel.prototype.SetIsShort = function (value) {
        this.IsShort = value;
        return this;
    };
    TrackedLinkModel.prototype.SetDoNotTrack = function (value) {
        this.DoNotTrack = value;
        return this;
    };
    TrackedLinkModel.prototype.SetFriendlyName = function (value) {
        this.FriendlyName = value;
        return this;
    };
    TrackedLinkModel.prototype.SetUrlPart = function (value) {
        this.UrlPart = value;
        return this;
    };
    TrackedLinkModel.prototype.SetLinkId = function (value) {
        this.LinkId = value;
        return this;
    };
    return TrackedLinkModel;
}());
export { TrackedLinkModel };
var TrackedLinkParser = /** @class */ (function () {
    function TrackedLinkParser() {
    }
    TrackedLinkParser.parse = function (input) {
        var delimiterIdx = input ? input.lastIndexOf("#") : -1;
        var urlPart = input;
        var parameters = {};
        if (delimiterIdx >= 0 && delimiterIdx < input.length - 1) {
            urlPart = input.substring(0, delimiterIdx);
            var trackingPart = input.substring(delimiterIdx + 1);
            parameters = this.getParams(trackingPart);
            // If this is an user anchor, we need to keep it
            if (!Object.keys(parameters).find(function (param) { return param.startsWith("_msdynmkt"); })) {
                urlPart = input;
            }
        }
        return new TrackedLinkModel()
            .SetDoNotTrack(this.tryGetBoolValue(parameters["_msdynmkt_donottrack"]))
            .SetFriendlyName(this.getDecodedStringValue(parameters["_msdynmkt_fn"]))
            .SetIsShort(this.tryGetBoolValue(parameters["_msdynmkt_isshort"]))
            .SetLinkId(this.getDecodedStringValue(parameters["_msdynmkt_linkid"]))
            .SetUrlPart(urlPart);
    };
    TrackedLinkParser.getParams = function (input) {
        var e_1, _a;
        var result = {};
        var parts = input.split(",");
        try {
            for (var parts_1 = __values(parts), parts_1_1 = parts_1.next(); !parts_1_1.done; parts_1_1 = parts_1.next()) {
                var part = parts_1_1.value;
                var subParts = part.split("=");
                if (subParts.length == 2) {
                    result[subParts[0]] = subParts[1];
                }
                else {
                    console.log("[TrackedLinkParser] Invalid link parameter '".concat(part, "'"));
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (parts_1_1 && !parts_1_1.done && (_a = parts_1.return)) _a.call(parts_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return result;
    };
    TrackedLinkParser.tryGetBoolValue = function (input) {
        var rawInput = input === null || input === void 0 ? void 0 : input.trim();
        if (rawInput === "1") {
            return true;
        }
        if (rawInput === "0") {
            return false;
        }
        return undefined;
    };
    TrackedLinkParser.getDecodedStringValue = function (input) {
        if (!input) {
            return input;
        }
        return decodeURI(input);
    };
    return TrackedLinkParser;
}());
export { TrackedLinkParser };
